import { translate as t } from '@thoughtspot/i18n';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { Key } from 'w3c-keys';
import { Icon, IconColor, IconID, IconSize } from '../../../../icon';
import styles from './header-cell.module.scss';
export var SortTypeEnum;
(function (SortTypeEnum) {
    SortTypeEnum[SortTypeEnum["asc"] = 0] = "asc";
    SortTypeEnum[SortTypeEnum["desc"] = 1] = "desc";
    SortTypeEnum[SortTypeEnum["none"] = 2] = "none";
})(SortTypeEnum || (SortTypeEnum = {}));
export var SortingIcon;
(function (SortingIcon) {
    SortingIcon["asc"] = "ARROW_UP";
    SortingIcon["desc"] = "ARROW_DOWN";
    SortingIcon["none"] = "EMPTY";
})(SortingIcon || (SortingIcon = {}));
export const SortableHeaderCell = ({ column, displayName, setSort, }) => {
    const sort = column.getSort();
    const colDef = column.getColDef();
    const [sorted, setSorted] = useState(sort || 'none');
    const SortLabels = {
        asc: t('ASCENDING'),
        desc: t('DESCENDING'),
        none: '',
    };
    const onSortChanged = () => {
        if (column.isSortAscending()) {
            setSorted('asc');
        }
        else if (column.isSortDescending()) {
            setSorted('desc');
        }
        else {
            setSorted('none');
        }
    };
    const onSortRequested = () => {
        var _a;
        if (!(colDef === null || colDef === void 0 ? void 0 : colDef.sortable)) {
            return;
        }
        const nextSortingMapper = {
            desc: 'asc',
            asc: 'desc',
            none: ((_a = colDef === null || colDef === void 0 ? void 0 : colDef.headerComponentParams) === null || _a === void 0 ? void 0 : _a.initialSortSelection) || 'asc',
        };
        const newSort = nextSortingMapper[sorted];
        setSort(newSort);
    };
    const onSortRequestedByEnter = (e) => {
        if (e.key === Key.Enter) {
            onSortRequested();
        }
    };
    useEffect(() => {
        column.addEventListener('sortChanged', onSortChanged);
        return () => {
            column.removeEventListener('sortChanged', onSortChanged);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const isSortable = !!(colDef === null || colDef === void 0 ? void 0 : colDef.sortable);
    const sortClassNames = cx(styles.sortIcon, {
        [styles.notSorted]: SortingIcon[sorted] === 'EMPTY',
        [styles.sortedDESC]: SortingIcon[sorted] === 'ARROW_DOWN',
        [styles.sortedASC]: SortingIcon[sorted] === 'ARROW_UP',
    });
    return (React.createElement("div", { role: "button", tabIndex: 0, onKeyPress: onSortRequestedByEnter, onClick: onSortRequested, className: styles.sortableHeaderCell },
        React.createElement("span", { className: cx(styles.headerCellContainer, {
                [styles.sortableColumnHeader]: isSortable,
                [styles.unsortableColumnHeader]: !isSortable,
            }), "aria-label": `${displayName} ${SortLabels[sorted]}` },
            displayName,
            isSortable && (React.createElement(Icon, { id: IconID.ARROW_DOWN, color: IconColor.TEXT_COLOR, size: IconSize.SMALL, className: sortClassNames })))));
};
//# sourceMappingURL=sortable-header-cell.js.map